// 全局配置文件
import {getRandomString} from '@/utils/base';

export const isDev = process.env["NODE_ENV"] === "test";  // 废弃
export const __env = process.env; // 废弃


// 前缀域名，需要根据接口环境不同动态拼接
const apiPrefixGroup = {
  hn_base: {
    dev: 'https://hn-d.ruguoyoubao.com',
    test: 'https://hn-t.ruguoyoubao.com',
    prod: 'https://hn.ruguoyoubao.com',
  },
  base: {
    // dev: 'https://wisdomcloud-dev.heiniubao.com', //开发环境
    dev: 'http://192.168.31.243:8080',
    test: 'https://wisdomcloud-test.heiniubao.cn',  //测试环境
    prod: 'https://wisdomcloud.heiniubao.cn', //生产环境
  },
  // 测试、生产都调测试环境
  fixBaseTest: {
    dev: 'https://wisdomcloud-dev.heiniubao.com', //开发环境
    test: 'https://wisdomcloud-test.heiniubao.cn',  //测试环境
    prod: 'https://wisdomcloud-test.heiniubao.cn', //生产环境
  },
  ffx: {
    dev: 'https://ffx-dev.heiniubao.com',
    test: 'https://ffx-new-test.heiniubao.cn',
    prod: 'https://ffx-new.heiniubao.com',
  },
  user_account: {
      dev: 'https://hn-d.ruguoyoubao.com',
      test: 'https://hn-t.ruguoyoubao.com',
      prod: 'https://hn.ruguoyoubao.com',
  },
  // rgyb fs
  attend: {
    dev: 'https://fscallmanager-dev.heiniubao.com',
    test: 'https://fscallmanager-test.heiniubao.com',
    prod: 'https://fscallmanager.heiniubao.com',
  },
  // rgyb fs 初始化域名
  initFsHost: {
    dev: 'opensips-dev.heiniubao.com',
    test: 'opensips-test.heiniubao.com',
    prod: 'opensips-call.heiniubao.com',
  },
  // AI大模型
  ai: {
    dev: 'https://hn-d.ruguoyoubao.com',
    test: 'https://hn-t.ruguoyoubao.com',
    prod: 'https://lsm.heiniubao.com',
  },
  fixAiTest: {
    dev: 'https://hn-d.ruguoyoubao.com',
    test: 'https://hn-t.ruguoyoubao.com',
    prod: 'https://hn-t.ruguoyoubao.com',
  },
  // 电销
  telemarketing: {
    dev: 'https://telemarketing-dev.heiniubao.com',
    test: 'https://telemarketing-test.heiniubao.com',
    prod: 'https://telemarketing.heiniubao.com',
  },
};

// 脚本命令
const MY_CMD = process.env.MY_CMD;

// 是否本地开发环境
const isLocal = ['start', 'start:test', 'start:pro'].includes(MY_CMD);

// 接口环境
let apiEnv = 'dev';
if (['start:test', 'build:test'].includes(MY_CMD)) apiEnv = 'test';
if (['start:pro', 'build'].includes(MY_CMD)) apiEnv = 'prod';

// 是否测试情况（非正式线上版本，一般用来开启日志调试）
export const isBeta = ['start', 'start:test', 'start:pro', 'build:dev', 'build:test'].includes(MY_CMD);
export const fileVersion = apiEnv !== 'prod' ? `V${getRandomString(6)}` : 'V1.0.1'; //oss在线文件链接 拼接版本号


// 项目配置
const config = {
  env: __env, //环境变量
  isDev, //是否是 development / test 模式

  apiPrefixGroup, //接口前缀
  MY_CMD, //脚本命令
  isLocal, //是否本地开发环境
  apiEnv, //接口环境
  isBeta, //是否测试情况（非正式线上版本，一般用来开启日志调试）
  fileVersion,  //oss在线文件链接 拼接版本号
}

export {
  apiEnv
}

console.log('%c project config => ', 'color: #fff; background-color: #38B0B7;', config);
export default config
